import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'


Vue.use(VueRouter)

// vue-router 3.x：重复 push/replace 到当前路由时会抛 NavigationDuplicated，全局静默处理
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    redirect:'/home/index',
    children:[
      //配置子路由
      {
        path:'index',
        name:'index',
        component:()=>import('@/components/IndexVue.vue')
      },
      {
        path:'details',
        name:'details',
        component:()=>import('@/components/DetailsVue.vue')
      },
      {
        path:'historyDetails',
        name:'historyDetails',
        component:()=>import('@/components/HistoryDetailsVue.vue')
      },
      {
        path:'project',
        name:'project',
        component:()=>import('@/components/ProjectVue.vue')
      },
      {
        path:'video',
        name:'video',
        component:()=>import('@/components/VideoworkVue.vue')
      },
      {
        path:'private',
        name:'private',
        component:()=>import('@/components/model/PrivateVue.vue')
      },
      {
        path:'videotwo',
        name:'videotwo',
        component:()=>import('@/components/model/VideoVue.vue')
      },
      {
        path:'usercenter',
        name:'usercenter',
        component:()=>import('@/components/user/MyCenter.vue')
      },
      {
        path: 'credit-redeem',
        redirect: { path: '/home/usercenter', query: { tab: 'redeem' } },
      },
      {
        path: 'workBox',
        name: 'workBox',
        component:()=>import('@/components/workBox/BoxListVue.vue')
      },
      {
        path: 'selectionsIdea',
        name: 'selectionsIdea',
        component:()=>import('@/components/workBox/SelectionsIdea.vue')
      },
      {
        path: 'videoCropping',
        name: 'videoCropping',
        component: ()=> import('@/components/workBox/VideoCropping.vue')
      },
      {
        path: 'videoCollect',
        name: 'videoCollect',
        component: ()=> import('@/components/workBox/VideoCollect.vue')
      },
      {
        path: 'videoTransGIF',
        name: 'videoTransGIF',
        component: ()=> import('@/components/workBox/VideoTransGIF.vue')
      },
      {
        path: 'pictureTransGIF',
        name: 'pictureTransGIF',
        component: ()=> import('@/components/workBox/PictureTransGIF.vue')
      },
      {
        path: 'getVideoText',
        name: 'getVideoText',
        component: ()=> import('@/components/workBox/GetVideoText.vue')
      },
      {
        path: 'projectDetails',
        name: 'projectDetails',
        component: ()=> import('@/components/projectdetail/ProjectDetail.vue')
      },
      {
        path: 'footage',
        name: 'footage',
        component: ()=> import('@/components/model/FootageModifications.vue')
      },
      {
        path: 'creation',
        name: 'creation',
        component: ()=> import('@/components/CreationVue.vue'),
      },
      {
        path: 'creationDetail',
        name: 'creationDetail',
        component: ()=> import('@/components/model/CreationDetail.vue')
      },
      {
        path: 'videocreate',
        name: 'videocreate',
        component: ()=> import('@/components/VideoCreate.vue')
      },
      {
        path: 'videolist',
        name: 'videolist',
        component: ()=> import('@/components/VideoList.vue')
      },
    
    ]
  },
  //忘记密码页面
  {
    path: '/resertpassd',
    name: 'resertpassd',
    component: () => import('@/components/user/ResetPassd.vue')
  },
  // 登录页面
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  //注册页面
  {
    path: '/enroll',
    name: 'enroll',
    component: () => import('@/views/EnrollVue.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('setPreviousRoute', from.fullPath)
  next()
})

export default router
